module.exports = __webpack_public_path__ + "static/media/game-banner-nick.fecbaf85.png";